































import { Vue, Component, Prop } from 'vue-property-decorator';
import { scrollToTop } from '../../utils/viewAction';
@Component({ components: {} })
export default class FooterSection extends Vue {
  scrollTo() {
    scrollToTop();
  }
}
